import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-IncludedValue",
  "use": "svg-icon-IncludedValue-usage",
  "viewBox": "1.6 1.9 16.7 16.2",
  "content": "<symbol viewBox=\"1.6 1.9 16.7 16.2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-IncludedValue\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666zm0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334zm3.884-9.79a.833.833 0 0 0-1.176.077l-3.764 4.299-1.663-1.816a.833.833 0 0 0-1.229 1.126l1.978 2.159a1.25 1.25 0 0 0 1.862-.021l4.07-4.649a.833.833 0 0 0-.078-1.176z\" fill=\"#434445\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol